import React from 'react'
import {useDispatch, useSelector} from "react-redux";
import {getCurrentSpaceThunk} from "../Feature/SpacesSlice";
import {Alert, Button, Card, Space, Spin, message} from "antd";
import {RightCircleOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import {CreateSpace} from "../Components/CreateSpace";
import {useSpacePersistence} from "../hooks/useSpacePersistence";


export const SelectSpace = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { saveLastSpaceId } = useSpacePersistence();
    const spaces = useSelector((state) => {
        return state.spaces
    })

    const enterSpace = (space) => {
        dispatch(getCurrentSpaceThunk(space.id)).unwrap().then(() => {
            saveLastSpaceId(space.id);
            navigate(`/spaces/${space.id}/`);
        }).catch(error => message.error('Unable to load space: ' + error.message))
    }

    return (
        <>
            <h1>
                Your Spaces
            </h1>
            <CreateSpace/>
            <Space direction="vertical" style={{width: '100%'}}>
                {spaces.status === 'failed' ?
                    <Alert message="Unable to load spaces" description={spaces.error} type="error" showIcon/> :
                    spaces.status === 'loading' ? <Spin/> :
                    spaces.spaces && spaces.spaces.length !== 0 ? (<>

                        {spaces.spaces.map(s =>
                            <Card key={s.id} title={`${s.space_name} Space`} bordered={false}>
                                <Button onClick={() => enterSpace(s)} type="primary" icon={<RightCircleOutlined/>}>
                                    {`Enter ${s.space_name} Space`}
                                </Button>
                            </Card>)}
                    </>)
                    : <Alert message="You are not part of a space yet." type="info"/>}


            </Space>
        </>
    );
}
